import { FormTextField } from '@orbis-systems/orbis-react-toolkit';
import React from 'react';

import { Grid } from '@mui/material';

import Form from '@components/forms';
import useEmailValidationForm from '@components/forms/emailValidation/hooks';
import { EmailValidationFormProps } from '@components/forms/emailValidation/interfaces';
import SubmitButton from '@components/submitButton';

function EmailValidationForm({ initialValues, onSubmit }: EmailValidationFormProps) {
	const { formik } = useEmailValidationForm({ initialValues, onSubmit });

	return (
		<Form formik={formik}>
			<Grid container spacing={3}>
				<Grid item xs={12}>
					<FormTextField
						name={'email'}
						label={'Email'}
						autoComplete="off"
						disabled={formik.isSubmitting}
						onChange={value => formik.setFieldValue('email', value.trim())}
					/>
				</Grid>

				<Grid item xs={12}>
					<SubmitButton label={'Continue'} disabled={formik.isSubmitting} />
				</Grid>
			</Grid>
		</Form>
	);
}

export default EmailValidationForm;
